const sponsorList = [
  {
    id: 1,
    name: "sponsor1.jpg",
    alt: "sponsor 1",
  },
  {
    id: 2,
    name: "sponsor2.png",
    alt: "sponsor 2",
  },
  {
    id: 3,
    name: "sponsor3.png",
    alt: "sponsor 3",
  },
  {
    id: 4,
    name: "sponsor4.png",
    alt: "sponsor 4",
  },
  {
    id: 5,
    name: "sponsor5.webp",
    alt: "sponsor 5",
  },
  {
    id: 6,
    name: "sponsor6.png",
    alt: "sponsor 6",
  },
  {
    id: 7,
    name: "sponsor7.png",
    alt: "sponsor 7",
  },
  {
    id: 8,
    name: "sponsor8.jpg",
    alt: "sponsor 8",
  },
  {
    id: 9,
    name: "sponsor9.jpg",
    alt: "sponsor 9",
  },
  // {
  //   id: 10,
  //   name: "sponsor10.jpg",
  //   alt: "sponsor 10",
  // },
  {
    id: 11,
    name: "sponsor11.png",
    alt: "sponsor 11",
  },
  {
    id: 12,
    name: "sponsor12.png",
    alt: "sponsor 12",
  },
];

export default sponsorList;
